import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisableCopyPasteDirective } from './disable-copy-paste.directive';



@NgModule({
  declarations: [DisableCopyPasteDirective],
  imports: [
    CommonModule
  ],
  exports:[DisableCopyPasteDirective]
})
export class DisableCopyPasteModule { }
